let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("chudj")).then(() => parcelRequire('8hlOJ'));